<template>
  <div class="index-view" :style="{
    '--height': height,
    '--shift1': shift1 + 'px', '--shift2': shift2 + 'px', '--shift3': shift3 + 'px', '--shift4': shift4 + 'px',
    '--shift5': shift5 + 'px', '--shift6': shift6 + 'px', '--shift7': shift7 + 'px', '--shift8': shift8 + 'px',
    '--shift9': shift9 + 'px', '--shift10': shift10 + 'px',
  }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ topName }}</div>
      <van-icon style="opacity: 0;" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="user-scroll">
      <div class="details-sc" v-if="type == 'A1' || type == 'A2' || type == 'A3'">
        <div class="run-image road1" v-if="type == 'A1'">
          <img :class="raccing == true ? 'raccing' : ''" src="../assets/road2.png" alt="">
          <div class="A1">
            <img :class="shift1 ? 'image1-active' : ''" src="../assets/che01.png" alt="">
            <img :class="shift2 ? 'image2-active' : ''" src="../assets/che02.png" alt="">
            <img :class="shift3 ? 'image3-active' : ''" src="../assets/che03.png" alt="">
            <img :class="shift4 ? 'image4-active' : ''" src="../assets/che04.png" alt="">
            <img :class="shift5 ? 'image5-active' : ''" src="../assets/che05.png" alt="">
            <img :class="shift6 ? 'image6-active' : ''" src="../assets/che06.png" alt="">
            <img :class="shift7 ? 'image7-active' : ''" src="../assets/che07.png" alt="">
            <img :class="shift8 ? 'image8-active' : ''" src="../assets/che08.png" alt="">
            <img :class="shift9 ? 'image9-active' : ''" src="../assets/che09.png" alt="">
            <img :class="shift10 ? 'image10-active' : ''" src="../assets/che10.png" alt="">
          </div>
        </div>
        <div class="run-image road2" v-if="type == 'A2'">
          <img :class="raccing == true ? 'raccing' : ''" src="../assets/road.png" alt="">
          <div class="A2">
            <img :class="shift1 ? 'image1-active' : ''" src="../assets/car1.png" alt="">
            <img :class="shift2 ? 'image2-active' : ''" src="../assets/car2.png" alt="">
            <img :class="shift3 ? 'image3-active' : ''" src="../assets/car3.png" alt="">
            <img :class="shift4 ? 'image4-active' : ''" src="../assets/car4.png" alt="">
            <img :class="shift5 ? 'image5-active' : ''" src="../assets/car5.png" alt="">
            <img :class="shift6 ? 'image6-active' : ''" src="../assets/car6.png" alt="">
            <img :class="shift7 ? 'image7-active' : ''" src="../assets/car7.png" alt="">
            <img :class="shift8 ? 'image8-active' : ''" src="../assets/car8.png" alt="">
            <img :class="shift9 ? 'image9-active' : ''" src="../assets/car9.png" alt="">
            <img :class="shift10 ? 'image10-active' : ''" src="../assets/car10.png" alt="">
          </div>
        </div>
        <div class="run-image road3" v-if="type == 'A3'">
          <img :class="raccing == true ? 'raccing' : ''" src="../assets/road1.png" alt="">
          <div class="A3">
            <img :class="shift1 ? 'image1-active' : ''" src="../assets/ma1.gif" alt="">
            <img :class="shift2 ? 'image2-active' : ''" src="../assets/ma2.gif" alt="">
            <img :class="shift3 ? 'image3-active' : ''" src="../assets/ma3.gif" alt="">
            <img :class="shift4 ? 'image4-active' : ''" src="../assets/ma4.gif" alt="">
            <img :class="shift5 ? 'image5-active' : ''" src="../assets/ma5.gif" alt="">
            <img :class="shift6 ? 'image6-active' : ''" src="../assets/ma6.gif" alt="">
            <img :class="shift7 ? 'image7-active' : ''" src="../assets/ma7.gif" alt="">
            <img :class="shift8 ? 'image8-active' : ''" src="../assets/ma8.gif" alt="">
            <img :class="shift9 ? 'image9-active' : ''" src="../assets/ma9.gif" alt="">
            <img :class="shift10 ? 'image10-active' : ''" src="../assets/ma10.gif" alt="">
          </div>
        </div>
        <div class="Lastperiod">
          <div>
            {{ $t("entertainment.lastBlock") }}：{{ betInfo.lastBlock }}
          </div>
          <div>{{ $t("details.resultValue") }}：{{ betInfo.resultValue }}</div>
        </div>
      </div>
      <div class="details-nv" v-else>
        <div :class="type == 'A6' ? 'wubeijing' : type == 'A7' ? 'wubeijing' : 'dt'" v-if="betInfo && daojishi == true">

          <div class="lhh " style="width: calc(100vw - 40px)" v-if="type == 'A6'">
            <img style="opacity:0.5" src="../assets/1113.png" alt="" />
            <img v-if="betInfo.winningResult == 'A601'" style="width: 139px;height: 139px;" src="../assets/1113.png"
              alt="" />
            <img v-else-if="betInfo.winningResult == 'A602'" style="width: 139px;height: 139px;"
              src="../assets/1112.png" alt="" />
            <img v-else style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />

            <img style="opacity:0.5" src="../assets/1112.png" alt="" />
            <div class="dingwei" style="display:flex">
              Hash:
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : ''">
                {{ item2.number }}</p>
            </div>
          </div>
          <div class="lhh" style="width: calc(100vw - 40px)" v-else-if="type == 'A7'">
            <div style="opacity:0.5;">
              <img style="width: 84px;height: 84px;" src="../assets/1114.png" alt="" />
              <div style="background: #00BFFF;">
                <p>{{ $t("entertainment.zhuang") }}</p>
              </div>
            </div>
            <img v-if="betInfo.winningResult == 'A701'" style="width: 139px;height: 139px;" src="../assets/1114.png"
              alt="" />
            <img v-else-if="betInfo.winningResult == 'A702'" style="width: 139px;height: 139px;"
              src="../assets/1115.png" alt="" />
            <img v-else style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />
            <div style="opacity:0.5;">
              <img style="width: 84px;height: 84px;" src="../assets/1115.png" alt="" />
              <div>
                <p>{{ $t("entertainment.idle") }}</p>
              </div>
            </div>
            <div class="dingwei" style="display:flex">
              Hash:
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : ''">
                {{ item2.number }}</p>
            </div>
          </div>
          <div v-else>
            <div class="jeiguo" style="">
              <p>{{ matchInfo[betInfo.winningResult.split(',')[0]] || betInfo.winningResult.split(',')[0] }}</p>
            </div>
            <div :class="matchBetInfo.flowOp == '1' ? 'win' : 'lose'" style="height:50px;line-height:96px">
              <!-- {{ matchBetInfo.flowOp == '1' ? 'WIN' : 'LOSE' }} -->
            </div>
            <div class="wenzi" style="display:flex;">
              <p>Hash:</p>
              <p v-for="(item2, index2) in betInfo.blockhash" :key="index2"
                :class="item2.colorred == true ? 'colorred' : ''">
                {{ item2.number }}</p>
            </div>
            <div :class="matchBetInfo.flowOp == '1' ? 'win' : 'lose'" style="height:50px;line-height:96px">
              <!-- {{ matchBetInfo.flowOp == '1' ? 'WIN' : 'LOSE' }} -->
            </div>
            <div class="jeiguo">
              <p style="margin-left: auto;">{{ matchInfo[betInfo.winningResult.split(',')[0]] ||
                  betInfo.winningResult.split(',')[0]
              }}</p>
            </div>
          </div>
        </div>
        <div v-else :class="type == 'A6' ? 'wubeijing' : type == 'A7' ? 'wubeijing' : 'dt dt-v'">
          <div class="lhh" style="width: calc(100vw - 40px)" v-if="type == 'A6'">
            <img src="../assets/1113.png" alt="" />
            <img style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />
            <img src="../assets/1112.png" alt="" />
          </div>
          <div class="lhh" style="width: calc(100vw - 40px)" v-else-if="type == 'A7'">
            <div>
              <img style="width: 84px;height: 84px;" src="../assets/1114.png" alt="" />
              <div style="background: #00BFFF;">
                <p>{{ $t("entertainment.zhuang") }}</p>
              </div>
            </div>
            <img style="width: 139px;height: 139px;" src="../assets/1111.png" alt="" />
            <div>
              <img style="width: 84px;height: 84px;" src="../assets/1115.png" alt="" />
              <div>
                <p>{{ $t("entertainment.idle") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="Lastperiod">
          <div>
            {{ $t("entertainment.lastBlock") }}：{{ betInfo.lastBlock }}
          </div>
          <div>{{ $t("details.resultValue") }}：{{ betInfo.resultValue }}</div>
        </div>
      </div>
      <div class="current">
        <div class="title">{{ $t("entertainment.currentblock") }}</div>
        <div style="height:4.25rem;display: flex;
			align-items: center;
			justify-content: center;">
          <div class="demo">
            <ul class="fp-box">
              <!-- 需要显示6列 -->
              <div class="box-back" v-for="item in 8" :key="item">
                <li ref="li">

                  <div v-for="num in 10" :key="num">
                    <p>{{ num - 1 }}</p>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="USDT">
        <div>
          {{ $t("entertainment.nextBlock") }}：<span>{{ betInfo.nextBlock }}</span>
        </div>
        <div @click="toLotteryRecord">
          <img src="../assets/img/kj.png">
          {{ $t("entertainment.toLotteryRecord") }}
        </div>
      </div>
      <div class="hash">
        <div class="block">
          <div>{{ $t("entertainment.block") }}</div>
          <div v-if="betInfo == ''">
            --
          </div>
          <div v-else @click="toBlock(matchBetInfo.height)" style="display:flex">
            {{ matchBetInfo.height }}
            <!-- <p
              v-for="(item2, index2) in matchBetInfo.blockhash"
              :key="index2"
              :class="item2.colorred == true ? 'colorred' : ''"
            >
              {{ item2.number }}</p> -->
          </div>
        </div>
        <div class="block">
          <div>{{ $t("entertainment.money1") }}</div>
          <div>{{ matchBetInfo ? matchBetInfo.number : '--' }}</div>
        </div>
        <div class="block">
          <div>{{ $t("entertainment.type") }}</div>
          <div>{{ matchBetInfo ? matchInfo[matchBetInfo.type] : '--' }}</div>
        </div>
        <div class="block">
          <div>{{ $t("details.resultValue") }}</div>
          <div style="color:#B51717">{{ matchBetInfo ? matchBetInfo.resultValue : '--' }}</div>
        </div>
      </div>
      <div class="all" @click="toHistory">
        <span>{{ $t("entertainment.all") }}>></span>
      </div>
      <div v-if="type == 'A1'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 4).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.both_sides") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(0, 4)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index == '0' ? $t('entertainment.big') : index ==
                      '1' ? $t('entertainment.small') : index == '2' ? $t('entertainment.single') :
                      $t('entertainment.double')
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
        <div class="thesizeofthe" v-if="betLists.slice(4, 14).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.champion") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(4, 14)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ index + 1 }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A2'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 10).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.champion") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(0, 10)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index + 1
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
        <div class="thesizeofthe" v-if="betLists.slice(10, 20).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.yajun") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(10, 20)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ index + 1 }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
        <div class="thesizeofthe" v-if="betLists.slice(20, 39).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.he") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(20, 39)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ index + 3 }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A3'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 10).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.champion_one_size") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(0, 10)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index + 1
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
        <div class="thesizeofthe" v-if="betLists.slice(10, 14).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.crown") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber  longnum" v-for="(item, index) in betLists.slice(10, 14)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ index == '0' ? $t("entertainment.andbig") : index == '1' ?
                      $t("entertainment.andsmall") : index == '2' ? $t("entertainment.andsingle") :
                        $t("entertainment.anddouble")
                  }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
        <div class="thesizeofthe" v-if="betLists.slice(14, 18).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.championtwo") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber longnum" v-for="(item, index) in betLists.slice(14, 18)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ index == '0' ? $t("entertainment.big") : index == '1' ? $t("entertainment.small")
                      : index == '2' ? $t("entertainment.single") :
                        $t("entertainment.double")
                  }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
              <div class="bignumber" style="height:0px;width:2.1875rem;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A4'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 4).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.both_sides") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber longnum" v-for="(item, index) in betLists.slice(0, 4)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index == '0' ? $t("entertainment.big") : index == '1' ? $t("entertainment.small")
                      : index == '2' ? $t("entertainment.single") :
                        $t("entertainment.double")
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A5'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 4).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.combination") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber longnum" v-for="(item, index) in betLists.slice(0, 4)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index == '0' ? $t("entertainment.forlarge") : index == '1' ?
                      $t("entertainment.smallsingle")
                      : index == '2' ? $t("entertainment.large_double") :
                        $t("entertainment.small_double")
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A6'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 3).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.Long_Huge") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber longnum" v-for="(item, index) in betLists.slice(0, 3)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index == '0' ? $t("entertainment.dragon") : index == '1' ? $t("entertainment.tiger")
                      : $t("entertainment.us")
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A7'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 3).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.baccarat") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber longnum" v-for="(item, index) in betLists.slice(0, 3)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">{{
                    index == '0' ? $t("entertainment.zhuang") : index == '1' ? $t("entertainment.idle")
                      : $t("entertainment.he")
                }}</div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
              <div class="bignumber longnum" style="height:0px;"></div>
            </van-grid>
          </div>
        </div>
      </div>
      <div v-if="type == 'A8'">
        <div class="thesizeofthe" v-if="betLists.slice(0, 10).length > 0">
          <div class="big">
            <div>{{ $t("entertainment.gallbladder") }}</div>
          </div>
          <div class="number">
            <van-grid :border="false" :column-num="4"
              style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div class="bignumber" v-for="(item, index) in betLists.slice(0, 10)" :key="index">
                <div @click="selectFirst(item)" :class="item.checked == true ? 'btnChecked' : ''">
                  {{ item.bidName.split('-')[1] }}
                </div>
                <div>{{ item.odds }}</div>
              </div>
              <div class="bignumber" style="opacity:0;height:0" v-for="(item, index) in betLists.slice(0, 3)"
                :key="index">
                <div></div>
                <div></div>
              </div>
            </van-grid>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <!-- <div style="color:#999999;padding:0 1rem 1rem;font-size:1rem">
        {{ articleLists.title }}
      </div> -->
      <div class="game" v-html="articleLists.content" style="color:#999999;padding:0 1rem 1rem">
      </div>

    </div>
    <van-dialog v-model="payShow" :cancel-button-text="$t('userInfo.cancel')"
      :confirm-button-text="$t('userInfo.determine')" @confirm="toPayFor" show-cancel-button>
      <div class="showPopover" style="position:unset;margin: 0 auto;background: #ffffff;width: 80%;padding-top: 2rem;">
        <div style="width: 100%;">
          <div style="font-size:1rem" v-for="(item, index) in betDetailsLists" :key="index" v-if="item.arr.length > 0">
            {{
                item.name == '大小' ? $t('entertainment.daxiao') : item.name == '冠军' ?
                  $t('entertainment.champion') : item.name == '冠军单码' ?
                    $t('entertainment.champion_one_size') : item.name == '冠亚和'
                      ?
                      $t('entertainment.crown')
                      : item.name == '冠军两面' ? $t('entertainment.championtwo') : item.name == '冠军' ?
                        $t('entertainment.champion') : item.crfname == '亚军' ? $t('entertainment.yajun') :
                          item.name ==
                            '和' ? $t('entertainment.he') : item.name == '两面' ? $t('entertainment.both_sides') :
                            item.name == '龙虎合' ? $t('entertainment.Long_Huge') : item.name == '百家乐' ?
                              $t('entertainment.baccarat') :
                              item.name == '组合' ? $t('entertainment.combination') : $t('entertainment.gallbladder')
            }}:
            ( <p v-for="(item1, index1) in item.arr" :key="index1">{{ index1 == '0' ? '' : '、' }}{{ item1 }}
            </p> ) <span>&nbsp;{{ $t('entertainment.Atotalof') }} {{ Number(item.arr.length) *
                Number(account
                  ||
                  0)
            }} {{ value }}</span></div>
        </div>
      </div>
    </van-dialog>
    <div style="position: relative;">
      <div v-if="showPopover" class="showPopover">
        <div>
          <div v-for="(item, index) in betDetailsLists" :key="index" v-if="item.arr.length > 0">{{
              item.name == '大小' ? $t('entertainment.daxiao') : item.name == '冠军' ?
                $t('entertainment.champion') : item.name == '冠军单码' ?
                  $t('entertainment.champion_one_size') : item.name == '冠亚和'
                    ?
                    $t('entertainment.crown')
                    : item.name == '冠军两面' ? $t('entertainment.championtwo') : item.name == '冠军' ?
                      $t('entertainment.champion') : item.name == '亚军' ? $t('entertainment.yajun') :
                        item.name ==
                          '和' ? $t('entertainment.he') : item.name == '两面' ? $t('entertainment.both_sides') :
                          item.name == '龙虎合' ? $t('entertainment.Long_Huge') : item.name == '百家乐' ?
                            $t('entertainment.baccarat') :
                            item.name == '组合' ? $t('entertainment.combination') : $t('entertainment.gallbladder')
          }}:
            ( <p v-for="(item1, index1) in item.arr" :key="index1">{{ index1 == '0' ? '' : '、' }}{{ item1 }}
            </p> ) <span>&nbsp;{{ $t("entertainment.Atotalof") }}{{ Number(item.arr.length) * Number(account
                ||
                0)
            }}{{ value }}</span></div>
        </div>
      </div>
      <div class="money">
        <div class="wallet">
          <div>[{{ $t("entertainment.Atotalof") }} <span>{{ betNumber }}</span> {{ $t("entertainment.note")
          }}<span @click="getDetails">{{ $t("entertainment.Check_the_details") }}</span>] {{
    $t("entertainment.Atotalof")
}} <span>{{
    allAccount || 0
}}</span> {{ value }}
          </div>
          <div>{{ $t("entertainment.money") }}：<span>{{ (value == 'USDT' ? walletInfo.usdtUsedPrice :
              walletInfo.trxUsedPrice) || '0'
          }} {{ value
}}</span>
          </div>
        </div>
        <div class="pause">
          <div class="reset">
            <div @click="machineSelection">
              <img src="../assets/img/jx.png">
              <p>{{ $t("entertainment.pause") }}</p>
            </div>
            <div @click="resetSelection">
              <img src="../assets/img/cz.png">
              <p>{{ $t("entertainment.reset") }}</p>
            </div>
          </div>
          <div class="submit">
            <div class="input">
              <div>
                <van-cell-group inset style="margin: 0">
                  <van-field @input="changeAccount" maxlength="5" type="number" v-model="account" :placeholder="tips" />
                </van-cell-group>
                <div class="select-icon">
                  <p @click="openIconShow">{{ value }}</p>
                  <van-icon @click="openIconShow" name="arrow-down" size="18" color="#ffffff" />
                  <div class="select-up" v-if="iconShow == true">
                    <div @click="changeValue('USDT')">
                      <p :class="value == 'USDT' ? 'active' : ''">USDT</p>
                      <van-icon name="success" size="24" color="#000000" v-if="value == 'USDT'" />
                    </div>
                    <div @click="changeValue('TRX')">
                      <p :class="value == 'TRX' ? 'active' : ''">TRX</p>
                      <van-icon name="success" size="24" color="#000000" v-if="value == 'TRX'" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="confirm" @click="toPayShow">
                <p>{{ $t("entertainment.submit") }}</p>
              </div>
            </div>
            <div class="USDTnumber">
              <span>{{ moneyRange.minUSDT }}-{{ moneyRange.maxUSDT }}USDT/{{ moneyRange.minTRX }}-{{
                  moneyRange.maxTRX
              }}TRX</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="passwordShow" @click="passwordShow = false">
      <div class="passwordShow-wrapper" @click.stop>
        <div class="block">
          <div class="index-view-top">
            <van-icon @click="passwordShow = false" name="cross" size="22" color="#565656" />
            <div class="title" style="font-size: 1rem">{{ $t("entertainment.password") }}</div>
            <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
          </div>
          <div class="block-details" style="opacity: 0;">{{ $t("entertainment.betting") }}</div>
          <div>
            <van-password-input :value="passwordValue" :gutter="10" :focused="showKeyboard = true"
              @focus="showKeyboard = true" />
            <!-- 数字键盘 -->
            <van-number-keyboard v-model="passwordValue" maxlength="6" :show="showKeyboard"
              @blur="showKeyboard = false" />
          </div>
          <div class="toPay" @click="toPayFor">
            <div>
              <p>{{ $t("entertainment.determine") }}</p>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { cityInfo, doHashCityInfo, doHashCity, walletInfo, article, racingRecordList, info } from '@/utils/request'
export default {
  inject: ['reload'],
  data() {
    return {
      showPopover: false,
      numberArr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], //固定每列中的19行数字
      numStr: '', // 需要展示的数字字符串
      numArr: [0, 0, 0, 0, 0, 0, 0, 0], //默认展示6个数字数组
      lucky: 1,
      show: true,
      showmoney: false,
      click_show: 0,
      style: {
        background: '#161414',
        'border-radius': '15px 15px 15px 15px',
        opacity: 1
      },
      passwordShow: false,
      topName: '', //顶部标题
      betInfo: '', //投注页面信息
      betLists: '', //下注信息
      type: '', //下注的类型
      betNumber: 0,
      options: [
        {
          value: 'USDT',
          label: 'USDT'
        },
        {
          value: 'TRX',
          label: 'TRX'
        }
      ],
      value: 'USDT',
      account: '', //单注金额
      allAccount: '', //总金额
      bidTypeArr: '', //下注类型（逗号拼接）参看项目文档-下注类型
      passwordValue: '',
      walletInfo: '', //钱包余额
      articleLists: '',
      height: '', //屏幕高度
      betInfo: '',
      matchBetInfo: '',
      matchInfo: {
        B101: this.$t('entertainment.big'),
        B102: this.$t('entertainment.small'),
        B103: this.$t('entertainment.single'),
        B104: this.$t('entertainment.double'),
        B201: this.$t('entertainment.forlarge'),
        B202: this.$t('entertainment.smallsingle'),
        B203: this.$t('entertainment.large_double'),
        B204: this.$t('entertainment.small_double'),
        B301: this.$t('entertainment.dragon'),
        B302: this.$t('entertainment.tiger'),
        B303: this.$t('entertainment.us'),
        B401: this.$t('entertainment.zhuang'),
        B402: this.$t('entertainment.idle'),
        B403: this.$t('entertainment.he'),
        B501: this.$t('entertainment.gallbladder'),
        A101: this.$t('entertainment.big'),
        A102: this.$t('entertainment.small'),
        A103: this.$t('entertainment.single'),
        A104: this.$t('entertainment.double'),
        A110: '1',
        A111: '2',
        A112: '3',
        A113: '4',
        A114: '5',
        A115: '6',
        A116: '7',
        A117: '8',
        A118: '9',
        A119: '10',
        A201: '1',
        A202: '2',
        A203: '3',
        A204: '4',
        A205: '5',
        A206: '6',
        A207: '7',
        A208: '8',
        A209: '9',
        A210: '10',
        A211: '1',
        A212: '2',
        A213: '3',
        A214: '4',
        A215: '5',
        A216: '6',
        A217: '7',
        A218: '8',
        A219: '9',
        A220: '10',
        A221: '3',
        A222: '4',
        A223: '5',
        A224: '6',
        A225: '7',
        A226: '8',
        A227: '9',
        A228: '10',
        A229: '11',
        A230: '12',
        A231: '13',
        A232: '14',
        A233: '15',
        A234: '16',
        A235: '17',
        A236: '18',
        A237: '19',
        A301: '1',
        A302: '2',
        A303: '3',
        A304: '4',
        A305: '5',
        A306: '6',
        A307: '7',
        A308: '8',
        A309: '9',
        A310: '10',
        A311: this.$t('entertainment.andbig'),
        A312: this.$t('entertainment.andsmall'),
        A313: this.$t('entertainment.andsingle'),
        A314: this.$t('entertainment.anddouble'),
        A315: this.$t('entertainment.big'),
        A316: this.$t('entertainment.small'),
        A317: this.$t('entertainment.single'),
        A318: this.$t('entertainment.double'),
        A401: this.$t('entertainment.big'),
        A402: this.$t('entertainment.small'),
        A403: this.$t('entertainment.single'),
        A404: this.$t('entertainment.double'),
        A501: this.$t('entertainment.forlarge'),
        A502: this.$t('entertainment.smallsingle'),
        A503: this.$t('entertainment.large_double'),
        A504: this.$t('entertainment.small_double'),
        A601: this.$t('entertainment.dragon'),
        A602: this.$t('entertainment.tiger'),
        A603: this.$t('entertainment.us'),
        A701: this.$t('entertainment.zhuang'),
        A702: this.$t('entertainment.idle'),
        A703: this.$t('entertainment.us'),
        A801: '1',
        A802: '2',
        A803: '3',
        A804: '4',
        A805: '5',
        A806: '6',
        A807: '7',
        A808: '8',
        A809: '9',
        A810: '0'
      },
      betDetailsLists: [],
      tips: this.$t('entertainment.inputmoney'), //输入框提示
      userInfo: '', //用户个人信息
      timer: '', //计时器
      payShow: false,
      moneyRange: '', //投注金额范围
      nowResult: '', //当前开奖结果
      shift1: '',
      shift2: '',
      shift3: '',
      shift4: '',
      shift5: '',
      shift6: '',
      shift7: '',
      shift8: '',
      shift9: '',
      shift10: '',
      raccing: false,
      loading: false,
      iconShow: false,
      daojishi: false
    }
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.topName = this.$route.query.name
    this.type = this.$route.query.type
    this.getBlockChange()
    this.getDoHashCityInfo()
    this.getUserInfo()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    openIconShow() {
      this.iconShow = !this.iconShow
    },
    changeValue(item) {
      this.value = item
      this.iconShow = false
    },
    toBlock(item) {
      if (this.matchBetInfo) {
        window.open('https://tronscan.io/#/block/' + item, '_blank')
      } else {
        item = ''
      }
    },
    async getDetails() {
      this.betDetailsLists = ''
      if (this.betNumber > 0) {
        let v = []
        let obj = [
          { name: '', arr: [] },
          { name: '', arr: [] },
          { name: '', arr: [] }
        ]
        await this.betLists.map(item => {
          if (item.checked == true) {
            if (v.indexOf(item.bidName.split('-')[0]) == -1) {
              v.push(item.bidName.split('-')[0])
            }
          }
        })
        console.log(v)
        await v.map((item, index) => {
          obj[index].name = item
          obj[index].arr = []
        })
        await this.betLists.map(item => {
          if (item.checked == true) {
            console.log(item.bidName.split('-')[1])
            obj.map(item1 => {
              if (item1.name == item.bidName.split('-')[0]) {
                item1.arr = [...item1.arr, item.bidName.split('-')[1]]
              }
            })
          }
        })
        this.betDetailsLists = obj
        this.showPopover = !this.showPopover
        console.log(this.betDetailsLists)
      }
    },
    //投注历史
    toHistory() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      this.$router.push({
        path: '/history',
        query: {
          type: this.type
        }
      })
    },
    toLotteryRecord() {
      this.$router.push({
        path: '/lotteryRecord',
        query: {
          type: this.type
        }
      })
    },
    getUserInfo() {
      info().then(res => {
        if (res.code == '200') {
          this.userInfo = res.data
        }
      })

      walletInfo().then(res => {
        if (res.code == '200') {
          this.walletInfo = res.data
        }
      })
      let temp
      if (this.type == 'A1') {
        temp = 1
      } else if (this.type == 'A2') {
        temp = 2
      } else if (this.type == 'A3') {
        temp = 3
      } else if (this.type == 'A4') {
        temp = 4
      } else if (this.type == 'A5') {
        temp = 5
      } else if (this.type == 'A6') {
        temp = 8
      } else if (this.type == 'A7') {
        temp = 6
      } else if (this.type == 'A8') {
        temp = 7
      }
      article({
        type: 'RULE_' + temp
      }).then(res => {
        if (res.code == '200') {
          this.articleLists = res.data
        }
      })
    },
    async toPayShow() {
      this.betDetailsLists = ''
      if (this.betNumber > 0) {
        let v = []
        let obj = [
          { name: '', arr: [] },
          { name: '', arr: [] },
          { name: '', arr: [] }
        ]
        await this.betLists.map(item => {
          if (item.checked == true) {
            if (v.indexOf(item.bidName.split('-')[0]) == -1) {
              v.push(item.bidName.split('-')[0])
            }
          }
        })
        console.log(v)
        await v.map((item, index) => {
          obj[index].name = item
          obj[index].arr = []
        })
        await this.betLists.map(item => {
          if (item.checked == true) {
            console.log(item.bidName.split('-')[1])
            obj.map(item1 => {
              if (item1.name == item.bidName.split('-')[0]) {
                item1.arr = [...item1.arr, item.bidName.split('-')[1]]
              }
            })
          }
        })
        this.betDetailsLists = obj
        this.payShow = true
        console.log(this.betDetailsLists)
      }
    },
    async toPayFor() {
      if (!localStorage.getItem('token')) {
        this.$router.push('/index')
        return
      }
      await this.betLists.map(item => {
        if (item.checked == true) {
          if (this.bidTypeArr) {
            this.bidTypeArr = this.bidTypeArr + ',' + item.bidType
          } else {
            this.bidTypeArr = item.bidType
          }
        }
      })
      doHashCity({
        type: this.$route.query.type,
        bidTypeArr: this.bidTypeArr,
        number: this.account,
        coin: this.value
      }).then(res => {
        if (res.code == '200') {
          this.bidTypeArr = ''
          this.passwordValue = ''
          this.account = ''
          this.betNumber = 0
          this.allAccount = 0
          this.$toast.success(this.$t('prompt.success'))
          this.resetSelection()
          this.getUserInfo()
        } else {
          this.$toast.fail(res.msg)
        }
        this.showKeyboard = false
        this.passwordShow = false
      })
    },
    changeAccount() {
      if (Number(this.account) > 0) {
        if (Number(this.account) > 10000) {
          this.account = 10000
          this.allAccount = Number(this.account) * this.betNumber
        } else {
          this.allAccount = Number(this.account) * this.betNumber
        }
      } else {
        this.allAccount = 0
      }
    },
    //重置
    resetSelection() {
      this.showPopover = false
      this.betNumber = 0
      this.betLists.map(item => {
        item.checked = false
      })
      this.changeAccount()
    },
    //机选
    machineSelection() {
      this.showPopover = false
      this.betLists.map(item => {
        item.checked = false
      })
      if (this.type == 'A1') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 4).length + 1) - 1
        var n = Math.floor(Math.random() * this.betLists.slice(4, 14).length + 1) - 1
        this.betLists.slice(0, 4)[m].checked = true
        this.betLists.slice(4, 14)[n].checked = true
      } else if (this.type == 'A2') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 10).length + 1) - 1
        var n = Math.floor(Math.random() * this.betLists.slice(10, 20).length + 1) - 1
        var o = Math.floor(Math.random() * this.betLists.slice(20, 39).length + 1) - 1
        this.betLists.slice(0, 10)[m].checked = true
        this.betLists.slice(10, 20)[n].checked = true
        this.betLists.slice(20, 39)[o].checked = true
      } else if (this.type == 'A3') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 10).length + 1) - 1
        var n = Math.floor(Math.random() * this.betLists.slice(10, 14).length + 1) - 1
        var o = Math.floor(Math.random() * this.betLists.slice(14, 18).length + 1) - 1
        this.betLists.slice(0, 10)[m].checked = true
        this.betLists.slice(10, 14)[n].checked = true
        this.betLists.slice(14, 18)[o].checked = true
      } else if (this.type == 'A4') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 4).length + 1) - 1
        this.betLists.slice(0, 4)[m].checked = true
      } else if (this.type == 'A5') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 4).length + 1) - 1
        this.betLists.slice(0, 4)[m].checked = true
      } else if (this.type == 'A6') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 3).length + 1) - 1
        this.betLists.slice(0, 3)[m].checked = true
      } else if (this.type == 'A7') {
        var m = Math.floor(Math.random() * this.betLists.slice(0, 3).length + 1) - 1
        this.betLists.slice(0, 3)[m].checked = true
      } else if (this.type == 'A8') {
        this.betLists.slice(0, 1)[0].checked = true
      }
      this.betNumber = 0
      this.betLists.map(item => {
        if (item.checked == true) {
          this.betNumber += 1
        }
      })

      this.changeAccount()
    },
    selectFirst(item) {
      this.showPopover = false
      item.checked = !item.checked
      this.betNumber = 0
      this.betNumber = 0
      this.betLists.map(item => {
        if (item.checked == true) {
          this.betNumber += 1
        }
      })
      this.changeAccount()
    },
    toBack() {
      this.$router.go('-1')
    },
    getDoHashCityInfo() {
      this.betLists = []
      doHashCityInfo({
        type: this.$route.query.type
      }).then(res => {
        if (res.code == '200') {
          res.data.dtoList.map(item => {
            item.checked = false
          })
          this.betLists = res.data.dtoList
          this.moneyRange = res.data
        }
      })
    },
    getBlockChange() {
      this.timer = setInterval(() => {
        racingRecordList({
          current: '1',
          size: '1',
          type: this.type,
          coin: this.value
        })
          .then(res => {
            if (res.code == '200' && res.data.records.length > 0) {
              res.data.records.map((item, index) => {
                let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
                let temp = [
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false },
                  { number: '', colorred: false, colorblue: false }
                ]
                for (let i = 0; i < blockhash.length; i++) {
                  temp[i].number = blockhash[i]
                  temp[i].colorred = false
                  temp[i].colorblue = false
                }
                let red = 0
                for (let i = blockhash.length - 1; i > 0; i--) {
                  if (blockhash[i] == item.resultValue.split(',')[0]) {
                    if (red == 0) {
                      temp[i].colorred = true
                      red = 1
                    }
                  } else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
                    if (red == 0) {
                      temp[i].colorred = true
                      red = 1
                    }
                  }
                }
                item.blockhash = temp
              })
              this.matchBetInfo = res.data.records[0]
              //console.log(this.matchBetInfo)
            }
          })
          .catch(error => {

          })
        cityInfo({
          type: this.$route.query.type
        }).then(res => {
          if (res.code == '200') {
            let time = new Date().getTime()
            if (res.data.createTimestamp && res.data.createTimestamp != localStorage.getItem('createTimestamp')) {
              localStorage.setItem('createTimestamp', res.data.createTimestamp)
            }
            if (!res.data.createTimestamp && localStorage.getItem('createTimestamp') && Number(time) - Number(localStorage.getItem('createTimestamp')) < 30000 && time > Number(localStorage.getItem('createTimestamp')) + 3000) {
              this.daojishi = true
            } else {
              this.daojishi = false
            }
            let blockhash = res.data.blockhash.slice(res.data.blockhash.length - 10, res.data.blockhash.length).split('')
            let temp = [
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false }
            ]
            for (let i = 0; i < blockhash.length; i++) {
              temp[i].number = blockhash[i]
              temp[i].colorred = false
              temp[i].colorblue = false
            }
            let red = 0
            for (let i = blockhash.length - 1; i > 0; i--) {
              if (blockhash[i] == res.data.resultValue.split(',')[0]) {
                if (red == 0) {
                  temp[i].colorred = true
                  red = 1
                }
              } else if (blockhash[i] == '0' && res.data.resultValue.split(',')[0] == '10') {
                if (red == 0) {
                  temp[i].colorred = true
                  red = 1
                }
              }
            }
            res.data.blockhash = temp
            this.betInfo = res.data
            if (res.data.nextBlock - res.data.currentBlock < 5) {
              this.$toast.fail(this.$t('data.fenpan'))
            }
            this.numStr = res.data.currentBlock
            this.numArr = this.numStr.split('')
            let numArrlen = this.numArr.length
            // 展示数字的处理，不够6位前面补0
            for (let i = 0; i < 8 - numArrlen; i++) {
              this.numArr.unshift(0)
            }
            this.$refs.li.forEach((item, index) => {
              let ty = this.numArr[index]
              // 滚动数字(li标签)
              item.style.transform = `translateY(-${ty * 35}px)`
            })
            if (this.nowResult != '') {
              if (this.nowResult == res.data.resultValue) {
              } else {
                this.shift1 = ''
                this.shift2 = ''
                this.shift3 = ''
                this.shift4 = ''
                this.shift5 = ''
                this.shift6 = ''
                this.shift7 = ''
                this.shift8 = ''
                this.shift9 = ''
                this.shift10 = ''
                this.raccing = false
                if (this.type == 'A1' || this.type == 'A2' || this.type == 'A3') {
                  setTimeout(() => {
                    this.reload()
                  }, 1)
                }
              }
            } else {
              if (res.data.resultValue) {
                this.nowResult = res.data.resultValue
                let arr = this.nowResult.split(',').slice(0, 2)
                this.raccing = true
                this.shift1 = Math.floor(Math.random() * 10) * 5
                this.shift2 = Math.floor(Math.random() * 10) * 5
                this.shift3 = Math.floor(Math.random() * 10) * 5
                this.shift4 = Math.floor(Math.random() * 10) * 5
                this.shift5 = Math.floor(Math.random() * 10) * 5
                this.shift6 = Math.floor(Math.random() * 10) * 5
                this.shift7 = Math.floor(Math.random() * 10) * 5
                this.shift8 = Math.floor(Math.random() * 10) * 5
                this.shift9 = Math.floor(Math.random() * 10) * 5
                this.shift10 = Math.floor(Math.random() * 10) * 5
                //console.log(arr, this.shift1, this.shift9)
                if (arr[0] == '1') {
                  this.shift1 = this.shift1 + 150
                } else if (arr[0] == '2') {
                  this.shift2 = this.shift2 + 150
                } else if (arr[0] == '3') {
                  this.shift3 = this.shift3 + 150
                } else if (arr[0] == '4') {
                  this.shift4 = this.shift4 + 150
                } else if (arr[0] == '5') {
                  this.shift5 = this.shift5 + 150
                } else if (arr[0] == '6') {
                  this.shift6 = this.shift6 + 150
                } else if (arr[0] == '7') {
                  this.shift7 = this.shift7 + 150
                } else if (arr[0] == '8') {
                  this.shift8 = this.shift8 + 150
                } else if (arr[0] == '9') {
                  this.shift9 = this.shift9 + 150
                } else if (arr[0] == '10') {
                  this.shift10 = this.shift10 + 150
                }
                if (arr[1] == '1') {
                  this.shift1 = this.shift1 + 80
                } else if (arr[1] == '2') {
                  this.shift2 = this.shift2 + 80
                } else if (arr[1] == '3') {
                  this.shift3 = this.shift3 + 80
                } else if (arr[1] == '4') {
                  this.shift4 = this.shift4 + 80
                } else if (arr[1] == '5') {
                  this.shift5 = this.shift5 + 80
                } else if (arr[1] == '6') {
                  this.shift6 = this.shift6 + 80
                } else if (arr[1] == '7') {
                  this.shift7 = this.shift7 + 80
                } else if (arr[1] == '8') {
                  this.shift8 = this.shift8 + 80
                } else if (arr[1] == '9') {
                  this.shift9 = this.shift9 + 80
                } else if (arr[1] == '10') {
                  this.shift10 = this.shift10 + 80
                }
              }
            }
          }
        })
      }, 1000)
    },
    clickshow(index) {
      console.log(index)
      this.click_show = index
    }
  }
}
</script>
<style>
page {
  background: #0c0b0b;
}
</style>
<style lang="scss" scoped="scoped">
.height {
  height: 100px;
}

.select-icon {
  display: flex;
  align-items: center;
  padding-right: 0.25rem;
  position: relative;

  .select-up {
    position: absolute;
    z-index: 999;
    top: -100px;
    right: 1rem;
    width: 11rem;
    background: #ffffff;
    border-radius: 0.5rem;
    padding: 0.5rem 0;

    .active {
      color: #409eff !important;
    }

    >div {
      padding: 0.3rem 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  >p {
    width: 36px;
    font-size: 0.8125rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.showPopover {
  width: 10rem;
  position: absolute;
  bottom: 8.75rem;
  color: #ffffff;
  background: #222121;
  left: 40px;
  padding: 0.75rem 0.75rem 0.25rem;
  border-radius: 1rem;

  >div {
    width: 10rem;

    >div {
      padding-bottom: 0.5rem;
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;

      >p {
        display: inline;
        color: #ffc400;
      }
    }
  }
}

/deep/.van-password-input__security li {
  width: 2.3125rem;
  height: 2.3125rem;
  background: #ffffff;
  border-radius: 0.3125rem;
}

.toPay {
  padding: 0.9375rem 0.9375rem 0;

  >div {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 40px;
  }
}

.passwordShow-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 1.875rem;

  .block {
    width: 100%;
    height: 11.0625rem;
    background: #161414;
    border-radius: 0.9375rem;

    .block-details {
      font-size: 0.75rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }

    .block-number {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 0.625rem 0 1rem;

      >p:nth-child(1) {
        font-size: 1.125rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffc400;
      }

      >p:nth-child(2) {
        font-size: 0.6875rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #565656;
      }
    }
  }
}

/deep/.el-select {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: -0.5rem;
  width: 4rem;

  .el-input__inner {
    background: none;
    font-size: 0.75rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #555555;
    // background: #161414;
    border: unset !important;
    padding: 0;
  }
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: unset;
}

/deep/ .van-field__control {
  color: #ffffff !important;
}

.road1 {
  >img {
    height: 340px !important;
  }

  >div {
    >img:nth-child(9) {
      right: 8px;
      top: 280px !important;
    }

    >img:nth-child(10) {
      right: 10px;
      top: 305px !important;
    }
  }
}

.road2 {
  >img {
    top: -20px !important;
  }
}

.road3 {}

.run-image {
  position: relative;
  // overflow: hidden;
  height: 380px;

  .raccing {
    animation-name: up, rotate;
    animation-duration: 9000ms, 18000ms;
    animation-timing-function: linear, linear;
    animation-delay: 1000ms, 10000ms;
    animation-iteration-count: 1, infinite;
    animation-fill-mode: forwards, none;

    @keyframes up {
      0% {
        right: 0px;
      }

      100% {
        right: -3000px;
      }
    }

    @keyframes rotate {
      0% {
        right: -3000px;
      }

      100% {
        right: -9000px;
      }
    }
  }

  >img {
    z-index: 1;
    width: 10700px;
    height: 350px;

    position: absolute;
    right: 0px;
  }

  .A1 {
    >img {
      position: absolute;
      width: 96px;
      height: 27px;
      z-index: 9;
    }
  }

  .A2 {
    margin-right: -20px;

    >img {
      position: absolute;
      width: 76px;
      height: 28px;
      z-index: 9;
      padding-right: 20px;
    }
  }

  .A3 {
    >img {
      position: absolute;
      width: 96px;
      height: 50px;
      z-index: 9;
    }
  }

  >div {
    @keyframes up1 {
      0% {
        right: -8px;
      }

      100% {
        right: var(--shift1);
      }
    }

    @keyframes up2 {
      0% {
        right: -6px;
      }

      100% {
        right: var(--shift2);
      }
    }

    @keyframes up3 {
      0% {
        right: -4px;
      }

      100% {
        right: var(--shift3);
      }
    }

    @keyframes up4 {
      0% {
        right: -2px;
      }

      100% {
        right: var(--shift4);
      }
    }

    @keyframes up5 {
      0% {
        right: -0px;
      }

      100% {
        right: var(--shift5);
      }
    }

    @keyframes up6 {
      0% {
        right: 2px;
      }

      100% {
        right: var(--shift6);
      }
    }

    @keyframes up7 {
      0% {
        right: 4px;
      }

      100% {
        right: var(--shift7);
      }
    }

    @keyframes up8 {
      0% {
        right: 6px;
      }

      100% {
        right: var(--shift8);
      }
    }

    @keyframes up9 {
      0% {
        right: 8px;
      }

      100% {
        right: var(--shift9);
      }
    }

    @keyframes up10 {
      0% {
        right: 10px;
      }

      100% {
        right: var(--shift10);
      }
    }

    .image1-active {
      animation: up1 9s forwards;
    }

    .image2-active {
      animation: up2 9s forwards;
    }

    .image3-active {
      animation: up3 9s forwards;
    }

    .image4-active {
      animation: up4 9s forwards;
    }

    .image5-active {
      animation: up5 9s forwards;
    }

    .image6-active {
      animation: up6 9s forwards;
    }

    .image7-active {
      animation: up7 9s forwards;
    }

    .image8-active {
      animation: up8 9s forwards;
    }

    .image9-active {
      animation: up9 9s forwards;
    }

    .image10-active {
      animation: up10 9s forwards;
    }

    >img:nth-child(1) {
      right: -8px;
      top: 54px;
    }

    >img:nth-child(2) {
      right: -6px;
      top: 81px;
    }

    >img:nth-child(3) {
      right: -4px;
      top: 110px;
    }

    >img:nth-child(4) {
      right: -2px;
      top: 140px;
    }

    >img:nth-child(5) {
      right: -0px;
      top: 164px;
    }

    >img:nth-child(6) {
      right: 2px;
      top: 194px;
    }

    >img:nth-child(7) {
      right: 4px;
      top: 225px;
    }

    >img:nth-child(8) {
      right: 6px;
      top: 254px;
    }

    >img:nth-child(9) {
      right: 8px;
      top: 278px;
    }

    >img:nth-child(10) {
      right: 10px;
      top: 300px;
    }
  }
}

.van-cell {
  background: none;
  padding: 0 0.375rem;
  font-size: 0.75rem;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #555555;
}

.van-cell-group {
  background: #1B1747;
  background: none;
  border-radius: 1.375rem;
  width: 4.5rem;
}

.user-scroll {
  height: calc(var(--height) - 10rem);
  overflow-y: scroll;
  overflow-x: hidden;
}

.dt-v {
  background-image: url('../assets/img1.png') !important;
}

.dongtu {
  margin: auto;
  animation-name: pulse;
  background-image: url('../assets/jg.png');
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* Safari and Chrome */
  -webkit-animation: mymove 1s;
  -webkit-animation-iteration-count: infinite;

  @keyframes mymove {
    0% {
      width: 130px;
      height: 190px;
    }

    25% {
      width: 135px;
      height: 195px;
    }

    50% {
      width: 140px;
      height: 200px;
    }

    75% {
      width: 135px;
      height: 195px;
    }

    100% {
      width: 130px;
      height: 190px;
    }
  }
}

.wenzi {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;

  >p {
    font-size: 0.75rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.lhh {
  display: flex;
  justify-content: center;
  padding: 30px 0;
  align-items: center;
  background: #161414;

  >div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >div {
      width: 45px;
      height: 28px;
      background: #90ee90;
      border-radius: 2px 2px 2px 2px;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }

  img {
    width: 92px;
    height: 73px;
  }
}

.colorred {
  color: #b51717 !important;
}

.btnChecked {
  background: RGBA(199, 157, 86, 1) !important;
  box-shadow: inset 0px -3px 6px 1px #AF730D;
  color: #ffffff !important;
}

.fp-box {
  display: flex;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .box-back {
    background: #ffffff;
    width: 2.1875rem;
    height: 2.1875rem;
    margin: 0 0.125rem;
    border-radius: 0.3125rem;
  }

  li {
    width: 2.1875rem;
    height: 2.1875rem;
    flex-direction: column;
    transition: transform 1s ease-in-out;

    >div {
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        text-align: center;
        font-size: 24px;
        color: #ffffff;
        font-size: 0.9375rem;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #ffc400;
      }
    }
  }
}

.index-view-top {
  height: 3.125rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.9375rem;

  .title {
    font-size: 1.125rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
  }
}

.money {
  // border: 1px solid;
  // height: 78px;
  background: #110E31;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  padding: 15px;
  // width: 93vw;
  // position: fixed;
  // bottom: 0;

  .pause {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .submit {
      .input {
        display: flex;
        justify-content: space-between;
        height: 30px;
        background: #1B1747;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;

        >div:nth-child(1) {
          display: flex;
          align-items: center;
          padding: 0 0.25rem;
          justify-content: space-between;
        }

        .confirm {
          width: 4rem;
          height: 1.875rem;
          background: linear-gradient(180deg, #ffdb67 0%, #ffc400 100%);
          border-radius: 0px 4px 4px 0px;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            font-size: 0.75rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #0c0b0b;
          }
        }
      }

      .USDTnumber {
        height: 15px;
        font-size: 11px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff693a;
        margin-top: 5px;
      }
    }

    .reset {
      display: flex;

      >div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        width: 56px;
        height: 28px;
        border-radius: 5px 5px 5px 5px;
        border: 1px solid #272727;

        >p {
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          padding-left: 0.125rem;
        }

        >img {
          width: 9px;
          height: 9px;
        }
      }
    }
  }

  .wallet {
    display: flex;
    justify-content: space-between;

    div {
      font-size: 13px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }

    div:nth-child(1) {
      span {
        color: #ffc400;
      }

      span:nth-child(2) {
        color: #ff693a;
      }
    }

    div:nth-child(2) {
      span {
        color: #ffffff;
      }
    }
  }
}

.line-one {
  height: 0px;
  opacity: 1;
  margin-top: 15px;
  border: 1px solid #272727;
  margin-bottom: 15px;
}

.game {
  padding: 0 15px;

  .details-Hash {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;

    span {
      color: #ff693a;
    }
  }

  .one {
    margin-bottom: 15px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #f8c007;
  }

  .gamerules {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffc400;

    span {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .TRX {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}

.line {
  margin-bottom: 15px;
  margin-top: 15px;
  height: 6px;
  background: #060505;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.Trc20 {
  margin-top: 25px;
  padding: 15px;
  // height: 73px;
  background: rgba($color: #ff693a, $alpha: 0.1);
  border-radius: 10px 10px 10px 10px;

  div:nth-child(1) {
    height: 17px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff693a;

    img {
      margin-right: 9px;
      width: 15px;
      height: 13px;
    }
  }

  div:nth-child(2) {
    margin-top: 5px;
    height: 19px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    margin-left: 28px;
  }
}

.jeiguo {
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  >p {
    font-size: 0.875rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffc400;
  }
}

.copy_address {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;

  div {
    text-align: center;
    line-height: 40px;
    margin-right: 15px;
    width: 100%;
    height: 43px;
    border-radius: 22px 22px 22px 22px;
    opacity: 1;
    border: 1px solid #f8c007;

    span {
      font-size: 15px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #f8c007;
    }
  }
}

.index-view {
  width: 100vw;
  height: 100vh;
  background: #020017;
  overflow-x: hidden;
  overflow-y: scroll;
}

.win {
  font-size: 1.125rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: green;
}

.wubeijing {
  background-image: unset !important;
}

.lose {
  font-size: 1.125rem;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #c85555;
}

.dingwei {
  color: #ffffff;
  position: absolute;
  display: flex;
  flex-direction: unset !important;
  width: 100%;
  bottom: 15px;
  z-index: 9999;

  >p {
    display: block;
    color: #ffffff;
  }
}

.USDT {
  margin: 20px 15px 15px;
  display: flex;
  justify-content: space-between;

  div:nth-child(1) {
    font-size: 14px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #999999;

    span {
      color: #ffc400;
    }
  }

  div:nth-child(2) {
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;

    img {
      width: 13px;
      height: 15px;
      margin-right: 5px;
      position: relative;
      top: 2px;
    }
  }
}

.thesizeofthe {
  border-bottom: 1px solid #272727;
  margin: 0 15px;
  padding: 15px 0 0 0;
  display: flex;
  justify-content: space-between;

  .big {
    width: 20%;
    min-width: 3.5rem;

    >div {
      font-size: 15px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      word-wrap: break-word;
    }
  }

  .number {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .longnum {
      width: 40%;
      margin: 0 0 0.9375rem !important;
    }

    .bignumber {
      text-align: center;
      margin: 0 1.5rem;
      margin-bottom: 0.9375rem;

      .clickdiv {
        min-width: 35px;
        height: 35px;
        box-shadow: inset 0px -1px 3px 1px rgba(226, 136, 0, 1);
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        font-size: 15px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #fff;
        line-height: 35px;
        background: rgb(223, 194, 82);
      }

      .clickdiv2 {
        min-width: 35px;
        height: 35px;
        background: #FFEDBE;
        box-shadow: inset 0px 2px 3px 1px rgba(0, 0, 0, 0.4);
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        font-size: 15px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #ffc400;
        line-height: 35px;
      }

      div:nth-child(1) {
        min-width: 19px;
        padding: 0 8px;
        height: 35px;
        background: #FFEDBE;
        box-shadow: inset 0px 2px 3px 1px rgba(0, 0, 0, 0.4);
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        font-size: 15px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #B6904D;
        line-height: 35px;
      }

      div:nth-child(2) {
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-top: 0.375rem;
      }
    }
  }
}

.all {
  font-size: 11px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #555555;
  text-align: center;
}

.hash {
  // height: 72px;
  background: #110E31;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  margin: 15px;
  padding: 15px;
  display: flex;
  justify-content: space-between;

  .block {
    width: 70px;
    text-align: center;

    div:nth-child(1) {
      font-size: 11px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      height: 2rem;
      overflow: hidden;
    }

    div:nth-child(2) {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding-top: 0.5rem;
    }
  }
}

.lhh {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}

.current {
  // width: 345px;
  height: 118px;
  margin: 0 15px;
  background: url(../assets/img/dqqk.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 99;

  .title {
    height: 50px;
    font-size: 14px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }

  .smallnumber {
    display: flex;
    justify-content: space-between;
    padding: 15px;

    div {
      text-align: center;
      line-height: 35px;
      width: 35px;
      height: 35px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
      opacity: 1;
      font-size: 15px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffc400;
    }
  }
}

.Lastperiod {
  position: absolute;
  background: rgba($color: #161414, $alpha: 0.78);
  border-radius: 0px 0px 10px 10px;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  z-index: 99;

  div {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  div:nth-child(1) {
    border-right: 1px solid #707070;
  }
}

.details-sc {
  text-align: center;
  position: relative;
  height: 400px;
  z-index: 99;

  .Lastperiod {
    position: absolute;
    background: rgba($color: #161414, $alpha: 0.78);
    border-radius: 0px 0px 10px 10px;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    z-index: 99;

    div {
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    div:nth-child(1) {
      border-right: 1px solid #707070;
    }
  }

  .vs {
    display: flex;
    justify-content: space-between;
    height: 136px;

    div {
      width: 111px;
      height: 100px;
      position: relative;

      img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        animation-name: pulse;
        /* Safari and Chrome */
        -webkit-animation: mymove 1s;
        -webkit-animation-iteration-count: infinite;

        @keyframes mymove {
          0% {
            width: 106px;
            height: 95px;
          }

          25% {
            width: 108px;
            height: 97px;
          }

          50% {
            width: 111px;
            height: 100px;
          }

          75% {
            width: 108px;
            height: 97px;
          }

          100% {
            width: 106px;
            height: 95px;
          }
        }
      }
    }
  }

  >img {
    width: 100%;
    height: auto;
  }
}

.details-nv {
  height: 300px;
  text-align: center;
  position: relative;

  .dt {
    padding-top: 15px;
    width: 160px;
    height: 210px;
    position: absolute;
    top: -50px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    animation-name: pulse;
    background-image: url('../assets/jg.png');
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    /* Safari and Chrome */
    -webkit-animation: mymove 1s;
    -webkit-animation-iteration-count: infinite;

    @keyframes mymove {
      0% {
        width: 160px;
        height: 210px;
      }

      25% {
        width: 165px;
        height: 215px;
      }

      50% {
        width: 170px;
        height: 220px;
      }

      75% {
        width: 165px;
        height: 215px;
      }

      100% {
        width: 160px;
        height: 210px;
      }
    }
  }
}

.wubeijing {
  width: calc(100vw - 40px);
  height: 210px;
  position: absolute;
  top: 20px;
  left: 20px;
  animation-name: pulse;
  background-image: unset;
  /* Safari and Chrome */
  -webkit-animation: mymove2 1s;
  -webkit-animation-iteration-count: infinite;

  @keyframes mymove2 {
    0% {
      transform: scale(1, 1);
    }

    25% {
      transform: scale(0.975, 0.975);
    }

    50% {
      transform: scale(0.95, 0.95);
    }

    75% {
      transform: scale(0.975, 0.975);
    }

    100% {
      transform: scale(1, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/luckyhash/entertainment.vue